import * as React from 'react';

import { AboutHome } from '../../components/AboutHome';
import { defaultRefWrapper, TRefWrapper } from '../Scrolling';
import { useSelector } from 'react-redux';
import { selectHouseInfo } from '../../selectors/houseInfo';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { VIEWED_TIMEOUT } from '../../constants/viewedBlock';
import { trackAboutHouseView } from '../../utils/teaser';
import { RefWrapper } from '../../components/packages/RefWrapper';
import { WarningContainer } from './WarningContainer';

export interface IAboutHomeContainerProps {
  refWrapper: TRefWrapper;
}

export function AboutHomeContainer({ refWrapper }: IAboutHomeContainerProps) {
  const houseInfo = useSelector(selectHouseInfo);

  if (!houseInfo.data) {
    return null;
  }

  const { isEmergency, isRenovation, items } = houseInfo.data;

  if (items.length === 0 && !isEmergency && !isRenovation) {
    return null;
  }

  return refWrapper(
    <RefWrapper>
      <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackAboutHouseView}>
        <AboutHome items={items} warningBanner={<WarningContainer />} />
      </ActionAfterViewObserver>
    </RefWrapper>,
  );
}

AboutHomeContainer.defaultProps = {
  refWrapper: defaultRefWrapper,
};
